<a class="link" href="{{ href }}">{{ 'LINKS.' + label | translate }}</a>
